module.exports = __webpack_public_path__ + "img/3_no.68426d68.svg";